import React from 'react';
import {
  StyledButtonSmall,
  StyledButtonSmallDisabled,
  StyledButtonSmallOutlined,
} from './styled.buttonSmall';
import { IButton } from './../../../../@types/button';
import { Loading } from './../../../icons/Loading';
import { Body6 } from '../../../../../app/common/typography';

export function ButtonSmall ({
  title,
  onClick,
  outlined,
  backgroundColor,
  inverted,
  disabled,
  loading,
  textColor,
  rounded,
  leftIcon,
  rightIcon,
}: IButton) {
  // title -> text inside the button
  // onClick -> function sent to parent
  // outlined -> if the button has outlined, the value must be TRUE (by default FALSE / 1px withe)
  // backgroundColor -> button color (follow the color in theme/default.ts)
  // inverted -> variable to invert the colors, this means, backgroundColor becomes outlineColor and backgroundColor becomes withe
  // disabled -> should be TRUE if the button is disabled

  if (disabled) {
    return (
      <StyledButtonSmallDisabled rounded={rounded}>
        {leftIcon || <span />}
        <Body6 color="white">{title}</Body6>
        {rightIcon || <span />}
      </StyledButtonSmallDisabled>
    );
  }

  if (outlined) {
    return (
      <StyledButtonSmallOutlined
        onClick={onClick}
        inverted={inverted}
        backgroundColor={backgroundColor}
        disabled={loading}
        textColor={textColor}
        rounded={rounded}
        loading={loading}
      >
        {loading ? (
          <Loading color={backgroundColor} size="sm" />
        ) : (
          <>
            {leftIcon || <span />}
            <Body6 color={inverted ? backgroundColor : textColor || 'white'}>
              {title}
            </Body6>
            {rightIcon || <span />}
          </>
        )}
      </StyledButtonSmallOutlined>
    );
  }

  return (
    <StyledButtonSmall
      onClick={onClick}
      backgroundColor={backgroundColor}
      disabled={loading}
      textColor={textColor}
      rounded={rounded}
      loading={loading}
    >
      {loading ? (
        <Loading size="sm" />
      ) : (
        <>
          {leftIcon || <span />}
          <Body6 color={textColor || 'white'}>{title}</Body6>
          {rightIcon || <span />}
        </>
      )}
    </StyledButtonSmall>
  );
}
